import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Shield = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Shield' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,22 C12,22 3,18 3,5 C3,5 12,2 12,2 C12,2 21,5 21,5 C21,18 12,22 12,22 Z M4,11 L20,11 M12,2 L12,22' />
  </StyledIcon>
);
